import CalendarPendingSolidSVG from "@design-system/ui-icons/vanilla/CalendarPendingSolid"
import { createIcon } from "../createIcon"

export const CalendarPendingSolidIcon = createIcon(CalendarPendingSolidSVG)
